import { render } from "./EditUserDetails.vue?vue&type=template&id=052f744e"
import script from "./EditUserDetails.vue?vue&type=script&lang=js"
export * from "./EditUserDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__